import apiFetch from '../apiFetch'

export default function (dossierId, token) {
  return apiFetch({ endPoint: `LandingAccess/${dossierId}/GetAllAvailableDocumentList`, method: 'GET', body: null, token: token })
}
